import React, { useState } from "react"
import {
  RelatedWrapper,
  RelatedWrapperInner,
  RelatedArticles as RelatedArticlesClass,
} from "./related-aticles.module.css"
import linkBuilder from "../../modules/linkBuilder"
import ArticleCardClean from "../article-card-clean/article-card-clean"
import VizSensor from "react-visibility-sensor"
import { dataLayer } from "../../modules/analytics"

const RelatedArticles = ({ articles }) => {
  const [visibleState, setVisibleState] = useState(false)

  const trackRelatedClick = () => {
    dataLayer({
      event: "related_articles_click_mkbsd",
      category: "related_articles",
    })
  }

  if (articles.length) {
    dataLayer({
      event: "related_articles_present_mkbsd",
      category: "related_articles",
    })
  }

  return (
    <>
      {!!articles.length && (
        <VizSensor
          active={!visibleState}
          partialVisibility
          minTopValue={400}
          onChange={async (isVisible) => {
            setVisibleState(isVisible)
            if (isVisible) dataLayer({
              event: "related_articles_visible_mkbsd",
              category: "related_articles",
            })
          }}
        >
          <div className={RelatedWrapper}>
            <div className={RelatedWrapperInner}>
              <h6>Ook interessant voor jou</h6>

              <div className={RelatedArticlesClass}>
                {articles.slice(0, 3).map((article, index) => {
                  //return <li key={`related-article-${index}`}><Link to={linkBuilder.article(article)} >{article.title}</Link></li>
                  return (
                    <div
                      key={article.id}
                      className="RelatedArticleCard"
                      onClick={trackRelatedClick}
                    >
                      <ArticleCardClean
                        title={article.title}
                        image={article.image?.gatsbyImageData}
                        link={linkBuilder.article(article)}
                        readMoreEndOfText={false}
                        footerPublicationDate={false}
                        footerDivider={false}
                      />
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </VizSensor >
      )}
    </>
  )
}

export default RelatedArticles
